import undoable, { distinctState } from 'redux-undo';
import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const draftRoute = (state = initialState.draftRoute, action) => {
    switch (action.type) {
        case types.ADD_DRAFTROUTE_POINTS:
            let stateArray = []
            state.map((point) => {
                stateArray.push({ lat: point.lat, lng: point.lng, ele: point.ele, dist: point.dist });
            });
            action.points.map((point) => {
                stateArray.push({ lat: point.lat, lng: point.lng, ele: point.ele, dist: point.dist  });
            });
            return stateArray;
        case types.DELETE_DRAFTROUTE_POINT:
            let deleteArray = []
            state.map((point) => {
                deleteArray.push({ lat: point.lat, lng: point.lng, ele: point.ele, dist: point.dist  });
            });
            deleteArray.splice(action.index, 1);
            return deleteArray; 
        case types.MOVE_DRAFTROUTE_POINT:
            let moveArray = []
            state.map((point) => {
                moveArray.push({ lat: point.lat, lng: point.lng, ele: point.ele, dist: point.dist  });
            });
            moveArray.splice(action.index, 1, { lat: action.point.lat, lng: action.point.lng, ele: action.point.ele, dist: action.point.dist  });
            return moveArray;
        case types.INSERT_DRAFTROUTE_POINT:
            let insertArray = []
            state.map((point) => {
                insertArray.push({ lat: point.lat, lng: point.lng, ele: point.ele, dist: point.dist });
            });
            insertArray.splice(action.index, 0, { lat: action.point.lat, lng: action.point.lng, ele: action.point.ele, dist: action.point.dist  });
            return insertArray;
        case types.SAVE_DRAFTROUTE:
            return action.draftRoute;
        case types.CLEAR_DRAFTROUTE:
            return [];
        //case types.LOGOUT_SUCCESS:
        //    return initialState.draftRoute;
        default:
            return state;
    }
}


const undoableDraftRoute = undoable(draftRoute, {
    filter: distinctState(),
    limit: 10
})

export default undoableDraftRoute

/* ... 
export default function draftRouteReducer(state = initialState.draftRoute, action) {
    switch (action.type) {
        case types.UPDATE_DRAFTROUTE_MAPTYPE:
            return {
                ...state,
                mapType: action.mapType
            };
        case types.UPDATE_DRAFTROUTE_ZOOM:
            return {
                ...state,
                zoom: action.zoom
            };
        case types.UPDATE_DRAFTROUTE_CENTRE:
            return {
                ...state,
                centre: action.centre
            };
        case types.UPDATE_DRAFTROUTE_POINTS:
            return {
                ...state,
                points: action.points
            }
        case types.UPDATE_DRAFTROUTE_CREATEMODE:
            return {
                ...state,
                createMode: action.createMode
            }
        case types.UPDATE_DRAFTROUTE_PLOTMODE:
            return {
                ...state,
                plotMode: action.plotMode
            }
        case types.SAVE_DRAFTROUTE:
            return action.draftRoute;
        case types.CLEAR_DRAFTROUTE:
            return action.draftRoute;
        default:
            return state;
    }
}
*/


// WEBPACK FOOTER //
// ./src/redux/reducers/draftRouteReducer.js